import { render, staticRenderFns } from "./ArticleInstagram.vue?vue&type=template&id=46a0e610&"
import script from "./ArticleInstagram.vue?vue&type=script&lang=ts&"
export * from "./ArticleInstagram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports